import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "src/app/base/services/base.service";
import { Observable } from "rxjs";
import { Pauta } from "../models/pauta.model";

@Injectable()
export class PautaService extends BaseService<Pauta> {

  constructor(public http: HttpClient) {
    super(http);
  }
  public getListCombos(id:number = null): Observable<any> {
    var url = id? '/list/'+id: '/list';
    return this.http.get<any>(this.baseUrl + url , { headers: this.headers });
  }
  public getListCombosAgency(id:number = null): Observable<any> {
    var url = id? '/list/accord/'+id: '/list/accord';
    return this.http.get<any>(this.baseUrl + url , { headers: this.headers });
  }

  public getPathModule(): string {
    return '/reuniao/pauta';
  }
}